import './StepFooter.scss';
import React from 'react';
import Store from 'state/Store';
import FooterButton from 'components/shared/FooterButton/FooterButton';
import { ReactComponent as Arrow } from 'assets/arrow.svg';
import { connect } from 'react-redux';
import { getCanContinue } from 'state/canContinue/CanContinueSelectors';
import { decreaseStep, increaseStep } from 'state/steps/StepActions';
import { lrnLifeEvents } from 'utils/LayoutUtils';

const StepFooter = ({
  canContinue,
  backButtonText = 'Back',
  continueButtonText = 'Continue',
  onBackClickURL = null,
  onContinueClickURL = null,
  showBackButton = true,
  showContinueButton = true,
  openParent = false,
  onClickFunction = null,
}) => {

  return (
    <div id="Footer">
      <footer className="save-footer">
        {showBackButton && (
          <span className="back-button">
            <FooterButton text={backButtonText}
                          icon={<Arrow />}
                          primary={false}
                          testId="sfBack"
                          openParent={openParent}
                          onClickURL={onBackClickURL}
                          onClickAction={() => {
                            Store.dispatch(decreaseStep());
                          }}
                          canContinue
            />
          </span>
        )}

        {showContinueButton && (
          <span className={showBackButton ? 'continue-button' : 'submit-button'}>
            <FooterButton text={continueButtonText}
                          primary
                          testId="sfContinue"
                          linkStyle={false}
                          onClickURL={onContinueClickURL}
                          openParent={openParent}
                          onClickAction={
                            onClickFunction
                              ? onClickFunction
                              : () => {
                                  Store.dispatch(increaseStep());
                                }
                          }
                          canContinue={canContinue}
            />
          </span>
        )}
      </footer>
      <span className="legal-reference-number"
            data-testid="death-notification-lrn"
      >{lrnLifeEvents}</span>
    </div>
  );
};

const mapStateToProps = (state) => ({
  canContinue: getCanContinue(state),
});

export default connect(mapStateToProps)(StepFooter);
